import useVleToken from '@api/hooks/csc/useVleToken'
import { Loader } from '@pw-tech/omni-ui'

import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { useNavigate, useSearchParams } from 'react-router-dom'

const CSCAuthorize = () => {
  const [isUserAuthorized, setIsUserAuthorized] = useState<boolean | null>(null)
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { mutate } = useVleToken()

  useEffect(() => {
    const code = searchParams.get('code')
    const data = {
      cscCode: code,
      organizationId: process.env.REACT_APP_PP_ORG_ID,
    }
    if (code) {
      mutate(data, {
        onSuccess: (response: any) => {
          if (response?.data?.success) {
            const cookieData = {
              randomId: localStorage.getItem('randomId') || '',
              token: response?.data?.data?.access_token,
              refresh_token: response?.data?.data?.refresh_token,
              expires_in: response?.data?.data?.expires_in,
            }
            const value = JSON.stringify(cookieData)
            setIsUserAuthorized(true)
            localStorage.setItem('token', response?.data?.data?.access_token)
            localStorage.setItem('TOKEN', response?.data?.data?.access_token)
            localStorage.setItem(
              'user',
              JSON.stringify(response?.data?.data?.user)
            )
            localStorage.setItem(
              'refresh_token',
              response?.data?.data?.refresh_token
            )
            const parts = window.location.hostname.split('.');
            const rootDomain = parts.slice(-2).join('.');
            document.cookie = `TOKEN_CONTEXT_AMBASSADOR=${value}; path=/; domain=.${rootDomain}; SameSite=Lax;`
            toast.success('Authorization successful!')
            navigate('/csc/dashboard')
          }
        },
        onError: (error: any) => {
          setIsUserAuthorized(false)
          toast.error('Authorization failed. Please try again.')
          navigate('/csc')
        },
      })
    } else {
      navigate('/csc')
    }
  }, [mutate, navigate, searchParams])

  if (isUserAuthorized === null) {
    return (
      <div className="flex h-full min-h-screen items-center justify-center">
        <Loader color="primary" size={'medium'} message="Please wait..." />
      </div>
    )
  }
  return <div></div>
}

export default CSCAuthorize
